// ======================================================================
// File Name       : FormControl
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormControl } from 'react-bootstrap';
import { onChangeWrapper } from '../../utils/FormUtils';

class FormControlCustom extends Component {
  handlePress(e) {
    if (e.key === 'Enter') {
      this.props.onEnter();
    }
  }

  render() {
    const newProps = { ...this.props };
    delete newProps.onEnter;
    return (
      <FormControl
        {...newProps}
        onChange={onChangeWrapper(this.props.onChange, this.props.value)}
        onKeyPress={this.handlePress.bind(this)}
      />
    );
  }
}

FormControlCustom.propTypes = {
  ...FormControl.propTypes,
  onEnter: PropTypes.func,
};
FormControlCustom.defaultProps = {
  ...FormControlCustom.defaultProps,
  onChange: () => false,
  onEnter: () => false,
};
export default FormControlCustom;
